<template>
    <div class="footer">
        WespiLift v.{{ appVersion }}. Copyright &copy; 2019 PT. WESP Indonesia. All rights reserved.
    </div>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            appVersion: localStorage.getItem("appVersion") || "0.0.0"
        }
    }
}
</script>

<style scoped>
.footer {
    /* position: fixed; */
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    text-align: center;
    font-size: 12px;
    padding: 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
